import axios from 'axios'

export const getRequestCancelToken = () => axios.CancelToken.source()
